import {
  TmsContextType,
  DataLayerFactory,
  DataLayerEventType,
  WishlistAddRemovePropertyImpressionPayload,
  type SearchSubmitPayload,
} from '@awaze/mfe-common.contexts.tms'
import { WishlistTrackEventType } from '@awaze/mfe-common.contexts.wishlist'
import { Regions } from '@awaze/mfe-common.types-and-mocks.one-search-client'
import type { SearchCriteria } from '@awaze/mfe-common.types-and-mocks.site-search-service'
import { ICommonAggregations } from '@awaze/mfe-common.types-and-mocks.site-search-service/types/properties.types'
import { dataLayerErrorHandler } from 'src/utils/dataLayerErrorHandler'
import { BuildApiUrlArgs, getPropertyInfo } from 'src/utils/getPropertyInfo'
import { buildMapImpressionAndClickPayload } from 'src/components/DynamicMap/DynamicMap.utils'

type GetPropertyInfoArgs = BuildApiUrlArgs

export const createSearchNoResultsPayload = (
  searchCriteria: SearchCriteria,
): SearchSubmitPayload => ({
  ...searchCriteria,
  adult: (searchCriteria.adult ?? '').toString(),
  child: (searchCriteria.child ?? '').toString(),
  infant: (searchCriteria.infant ?? '').toString(),
  nights: (searchCriteria.nights ?? '').toString(),
  pets: (searchCriteria.pets ?? '').toString(),
  range: (searchCriteria.range ?? '').toString(),
})

export const onWishlistTrack = async ({
  tms,
  eventName,
  clientHeader,
  propertyInfoArgs,
  propertyImpression,
}: {
  tms: TmsContextType
  eventName: string
  clientHeader: string
  propertyInfoArgs: GetPropertyInfoArgs
  propertyImpression: {
    aggregations: ICommonAggregations
    rhsLevel: Regions
    total: number
  }
}): Promise<void> => {
  const propertyInfo = await getPropertyInfo(propertyInfoArgs, clientHeader)

  if (propertyInfo?.property && tms) {
    new DataLayerFactory()
      .getEvent(DataLayerEventType.WishlistAddRemoveCard)
      .update(
        tms,
        {
          eventName: eventName,
          ...buildMapImpressionAndClickPayload(
            propertyInfoArgs.searchCriteria,
            propertyImpression.aggregations,
            propertyImpression.rhsLevel,
            propertyImpression.total,
            propertyInfo.property,
          ),
        } as WishlistAddRemovePropertyImpressionPayload,
        dataLayerErrorHandler,
      )
  }
}

export const wishlistTmsUpdateDataLayer = (
  tms: TmsContextType,
  event: WishlistTrackEventType,
  payload?: Record<string, unknown>,
): void => {
  tms.updateDataLayer('link', event, payload?.error_code ? payload : {})
}
